import { useEffect, useRef } from "react";
import { AiFillCheckSquare, AiFillDelete, AiFillEdit, AiFillCloseCircle } from "react-icons/ai";

const countWords = (text) => {
    if (!text.trim()) return 0;
    return text.trim().split(/\s+/).length;
};

export const HouseRuleItem = ({
    index, 
    rule, 
    editingIndex, 
    editingText,
    setEditingText,
    startEditing,
    cancelEdit,
    saveEdit,
    deleteRule,
    wordLimit
}) => {
    const inputRef = useRef(null);
    const wordCount = countWords(editingText);
    const isValid = wordCount >= 1 && wordCount <= wordLimit;
    const isEditing = editingIndex === index;

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isEditing]);

    const handleEnterKeyDown = e => {
        if (e.key === 'Enter') {
            saveEdit();
        }
    };
      
    return (
        <div
            key={index}
            className="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-mb-3 tw-border tw-rounded"
        >
            {isEditing ? (
            <div className="tw-flex-1 tw-w-full tw-min-w-0">
                <input
                    ref={inputRef}
                    onKeyDown={handleEnterKeyDown}
                    value={editingText}
                    onChange={(e) => {
                    const inputValue = e.target.value;
                    const inputWordCount = countWords(inputValue);
                    
                    if (inputWordCount <= wordLimit) {
                        setEditingText(inputValue);
                    }
                    }}
                    className={`form-control ${!isValid && editingText ? 'tw-border-red-500' : 'tw-border-gray-300'}`}
                    type="text"
                    name="houseRules"
                    placeholder="House Rules"
                />
                <div className={`tw-text-sm tw-mt-1 tw-text-gray-400`}>
                {wordCount}/{wordLimit} words
                </div>
            </div>
            ) : (
            <p className="tw-text-gray-700 tw-text-lg tw-flex-1 tw-min-w-0">
                {index + 1}. {rule}
            </p>
            )}
            
            <div className="tw-flex tw-gap-2 tw-flex-shrink-0">
            {isEditing ? (
                <>
                <AiFillCheckSquare
                    size={24}
                    onClick={saveEdit}
                    className={`tw-cursor-pointer ${
                    isValid ? 'tw-text-green-600 hover:tw-text-green-700' : 'tw-text-gray-400 tw-cursor-not-allowed'
                    }`}
                />
                <AiFillCloseCircle
                    size={24}
                    onClick={cancelEdit}
                    className="tw-cursor-pointer"
                />
                </>
            ) : (
                <>
                <AiFillEdit
                    size={24}
                    onClick={() => startEditing(index)}
                    className="tw-cursor-pointer"
                />
                <AiFillDelete
                    size={24}
                    onClick={() => deleteRule(index)}
                    className="tw-cursor-pointer"
                />
                </>
            )}
            </div>
        </div>
        );
        
}

export const HouseRuleInput = ({
    rule,
    setRule,
    wordLimit,
    handleSave
}) => {
const wordCount = countWords(rule);
const isValid = wordCount >= 1 && wordCount <= wordLimit;

const handleEnterKeyDown = e => {
    if (e.key === 'Enter') {
        handleSave()
    }
  };

return (
    <div className="tw-flex-col tw-w-full">
        <div>
            <input
            onKeyDown={handleEnterKeyDown}
            onChange={(e) => {
                const inputValue = e.target.value;
                const inputWordCount = countWords(inputValue);
                
                if (inputWordCount <= wordLimit) {
                setRule(inputValue);
                }
            }}
            value={rule}
            type="text"
            name="houseRules"
            className={`form-control ${!isValid && rule ? 'tw-border-red-500' : ''}`}
            placeholder="House Rules"
            required
            />
            <div className="tw-flex tw-justify-between tw-items-center tw-mt-1">
            <div className={`tw-text-sm tw-text-gray-400`}>
                {wordCount}/{wordLimit} words
            </div>
            
            {wordCount > wordLimit && (
                <div className="tw-text-xs tw-text-red-500">
                Exceeds limit by {wordCount - wordLimit} words
                </div>
            )}
            </div>
        </div>
        <p className="tw-text-sm tw-text-gray-400 tw-my-2">
            ⓘ Each rule must be 1-{wordLimit} words for clarity and readability
        </p>
    </div>
    )
}

export const HouseRulesExamples = () => {
    return (
    <div className="col-lg-6">
        <h4>House Rules (Examples)</h4>
        <div className="house-rules-list">
        <p className="tw-text-gray-800 tw-text-base tw-mb-2 house-rule-item" data-number="1">
            Be courteous and clean up after yourself
        </p>
        <p className="tw-text-gray-800 tw-text-base tw-mb-2 house-rule-item" data-number="2">
            Quiet hours are from 10pm-8am
        </p>
        <p className="tw-text-gray-800 tw-text-base tw-mb-2 house-rule-item" data-number="3">
            Provide your own sheets, towels, and toiletries
        </p>
        <p className="tw-text-gray-800 tw-text-base tw-mb-2 house-rule-item" data-number="4">
            Overnight guests are not allowed
        </p>
    </div>
  </div>
)
}